/* * 本页面为库区监测点新增和库区监测点修改界面 *
通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              v-if="pageType == 1"
              prop="forms.storageId"
              label="所属冷库"
              :rules="[
                {
                  required: true,
                  message: '请选择所属冷库',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.storageId"
                @change="storageChange"
                clearable
                filterable
                placeholder="所属冷库"
              >
                <el-option
                  v-for="item in allStorageInfo"
                  :key="item.storageId"
                  :label="item.storageName"
                  :value="item.storageId"
                ></el-option>
              </el-select>
              &nbsp;
              <router-link
                :to="{
                  path: '/baseStorageEdit'
                }"
                >新增冷库</router-link
              >
            </el-form-item>

            <el-form-item
              v-if="pageType == 2"
              prop="forms.storageId"
              label="所属冷库"
              :rules="[
                {
                  required: true,
                  message: '请选择所属冷库',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.storageId"
                @change="storageChange"
                clearable
                disabled
                filterable
                placeholder="所属冷库"
              >
                <el-option
                  v-for="item in allStorageInfo"
                  :key="item.storageId"
                  :label="item.storageName"
                  :value="item.storageId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="pageType == 1"
              prop="forms.storageAreaId"
              label="所属库区"
              :rules="[
                {
                  required: true,
                  message: '请选择所属库区',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.storageAreaId"
                clearable
                filterable
                placeholder="所属库区"
              >
                <el-option
                  v-for="item in allStorageAreaInfo"
                  :key="item.storageAreaId"
                  :label="item.storageAreaName"
                  :value="item.storageAreaId"
                ></el-option>
              </el-select>
              &nbsp;
              <router-link
                :to="{
                  path: '/baseStorageAreaEdit'
                }"
                >新增库区</router-link
              >
            </el-form-item>
            <el-form-item
              v-if="pageType == 2"
              prop="forms.storageAreaId"
              label="所属库区"
              :rules="[
                {
                  required: true,
                  message: '请选择所属库区',
                  trigger: 'blur'
                }
              ]"
            >
              <el-select
                disabled
                v-model="slotForms.forms.storageAreaId"
                clearable
                filterable
                placeholder="所属库区"
              >
                <el-option
                  v-for="item in allStorageAreaInfo"
                  :key="item.storageAreaId"
                  :label="item.storageAreaName"
                  :value="item.storageAreaId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="监测点名称"
              prop="forms.labelName"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点名称',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.labelName"
                placeholder="监测点名称"
                clearable
                @blur="checkLabelName"
              ></el-input>

              <div :class="{ alarmColor: labelNameAlarmFlag }">
                {{ labelNameMessage }}
              </div>
            </el-form-item>
            <el-form-item
              label="监测点唯一标识码"
              prop="forms.uuid"
              :rules="[
                {
                  required: true,
                  message: '请输入监测点唯一标识码',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.uuid"
                placeholder="监测点唯一标识码"
                clearable
                @blur="checkLabelUuid"
              ></el-input>
              <div :class="{ alarmColor: labelUuidAlarmFlag }">
                {{ labelUuidMessage }}
              </div>
            </el-form-item>
            <el-form-item
              label="监测点位置"
              prop="forms.labelPosition"
              :rules="[
                {
                  required: false,
                  message: '请输入监测点位置',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.labelPosition"
                placeholder="监测点位置"
                clearable
              ></el-input>
              <div :class="{ alarmColor: labelPositionAlarmFlag }">
                {{ labelPositionMessage }}
              </div>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import {
  FindStorageAreaLabelInfoById,
  SaveStorageAreaLabelInfo,
  CheckNameUniqueData
} from "@/api/base/storageAreaLabel";
import {
  FindStorageAreaAllByStorageId,
  FindStorageAll
} from "@/api/base/storageArea";
import resizeListener from "_private/mixins/resizeListener";
import { CheckRemarkLength, CheckComparyNameLength } from "@/utils/validation";
export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/baseStorageAreaLabelList",
          isRedirect: true,
          meta: {
            title: "库区监测点"
          }
        }
      ],
      formExtend: {
        forms: {
          storageAreaId: "",
          freezerId: "",
          storeId: "",
          labelName: "",
          uuid: "",
          labelPosition: ""
        },
        extends: []
      },
      labelNameMessage: "",
      labelUuidMessage: "",
      labelPositionMessage: "",
      labelNameAlarmFlag: false,
      labelUuidAlarmFlag: false,
      labelPositionAlarmFlag: false,
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      CheckComparyNameLength: CheckComparyNameLength,
      loadingState: false,
      allStorageInfo: [],
      allStorageAreaInfo: [],
      isFirstLoad: true
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle =
        this.pageType === "1" ? "库区监测点新增" : "库区监测点修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    },
    storageId() {
      return this.$route.query.storageId;
    }
  },
  created() {
    this.initAllStorage();
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
    if (this.pageType !== "1") {
      this.FindStorageAreaLabelInfoById({ labelId: this.id });
      this.editState = true;
    }
  },
  mounted() {},
  methods: {
    /**
     * 初始化冷库下拉框
     */
    initAllStorage() {
      FindStorageAll().then(response => {
        if (
          response.result &&
          response.result &&
          Array.isArray(response.result)
        ) {
          this.allStorageInfo = response.result;
        }
      });
    },
    //门店选择事件
    storageChange() {
      this.allStorageAreaInfo = [];
      this.formExtend.forms.storageAreaId = "";
      this.FindStorageAreaAllByStorageId({
        storageId: this.formExtend.forms.storageId
      });
    },
    /**
     * 初始化库区下拉框
     */
    FindStorageAreaAllByStorageId(storageId) {
      FindStorageAreaAllByStorageId(storageId).then(response => {
        if (
          response.result &&
          response.result &&
          Array.isArray(response.result)
        ) {
          this.allStorageAreaInfo = response.result;
        }
      });
    },
    /**
     * 校验监测点名称唯一性
     */
    checkLabelName() {
      if (
        this.formExtend.forms.labelName &&
        this.formExtend.forms.labelName.indexOf(" ") == -1
      ) {
        CheckNameUniqueData({
          storageAreaId: this.formExtend.forms.storageAreaId,
          labelName: this.formExtend.forms.labelName,
          labelId: this.id
        }).then(response => {
          if (response.code == 0) {
            if (response.message) {
              this.labelNameAlarmFlag = true;
              this.labelNameMessage = response.message;
            }
          } else {
            this.labelNameAlarmFlag = false;
            this.labelNameMessage = response.message;
          }
        });
      }
    },
    //校验唯一码唯一性
    checkLabelUuid() {
      if (
        this.formExtend.forms.labelName &&
        this.formExtend.forms.uuid.indexOf(" ") == -1
      ) {
        CheckNameUniqueData({
          storageAreaId: this.formExtend.forms.storageAreaId,
          uuid: this.formExtend.forms.uuid,
          labelId: this.id
        }).then(response => {
          if (response.code == 0) {
            if (response.message) {
              this.labelUuidAlarmFlag = true;
              this.labelUuidMessage = response.message;
            }
          } else {
            this.labelUuidAlarmFlag = false;
            this.labelUuidMessage = response.message;
          }
        });
      }
    },

    // 修改库区监测点数据时，先获取库区监测点数据信息
    FindStorageAreaLabelInfoById(response) {
      FindStorageAreaLabelInfoById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result);
          this.formExtend.forms.storageId = this.storageId;
          this.FindStorageAreaAllByStorageId({ storageId: this.storageId });
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增，修改库区监测点数据
    SaveStorageAreaLabelInfo(response) {
      SaveStorageAreaLabelInfo(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增库区监测点信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseStorageAreaLabelList",
              query: { refreshportion: true }
            });
          }
          this.loadingState = false;
        }
      });
    },
    // 提交
    handleSubmitForm(e) {
      if (e && !this.labelNameAlarmFlag && !this.labelUuidAlarmFlag) {
        this.loadingState = true;
        this.SaveStorageAreaLabelInfo(Object.assign({}, this.formExtend.forms));
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/baseStorageAreaLabelList");
    }
  }
};
</script>

<style lang="scss" scoped>
.alarmColor {
  margin-bottom: -21px;
  margin-top: -5px;
  font-size: 12px;
  color: #f56c6c;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}
</style>
